module.exports = __webpack_public_path__ + "img/flag_en.82063525.svg";